import deliveryMethods from '../mixins/delivery-methods'
export default {
  methods: {        
    /**
     * Cookieに保存されている請求先コードの返却を行う
     * @returns 
     */
    getBillingCodeByCookie () {
      return this.$cookies.get(deliveryMethods.COOKIE_SAVE_KEY);
    },
    /**
     * Cookieへ請求ユーザーコードを保存する
     * @param {*} value 
     */        
    setBillingUserCodeToCookie (value) {        
        this.$cookies.set(deliveryMethods.COOKIE_SAVE_KEY, value);
    },    
    /**
     * Cookieの削除を行う
     */
    deleteCookie() {
        this.$cookies.remove(deliveryMethods.COOKIE_SAVE_KEY);
    },
  }
};



// WEBPACK FOOTER //
// ./src/mixins/CookieUtil.js